import { cx } from 'class-variance-authority'
import { CheckIcon } from '@phosphor-icons/react/dist/ssr/Check'
import { XIcon } from '@phosphor-icons/react/dist/ssr/X'
import { ArrowRightIcon } from '@phosphor-icons/react/dist/ssr/ArrowRight'

import { Picture } from '@/types'

type PictureTrProps = {
  picture: Picture
  index: number
}

export const PictureTr = (props: PictureTrProps) => {
  const { picture, index } = props

  return (
    <tr className={index % 2 === 0 ? undefined : 'bg-gray-50'}>
      <td className="flex flex-row gap-4 whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-3">
        <div
          className={cx({
            'relative shrink-0 rounded-lg border-2': true,
            ' border-red-500': !picture.productID,
            ' border-green-500': picture.productID,
          })}
        >
          <img
            className="h-20 w-20 rounded-md object-cover"
            src={picture.image}
            alt={picture.name}
          />
          <div className="absolute -bottom-2 -right-2">
            {picture.productID ? (
              <div className="rounded-full bg-green-500 p-1">
                <CheckIcon className="size-4" />
              </div>
            ) : (
              <div className="rounded-full bg-red-500 p-1">
                <XIcon className="size-4" />
              </div>
            )}
          </div>
        </div>
        <div className="line-clamp-3 flex max-h-20 w-[250px] flex-col justify-center">
          <span className="text-wrap text-sm text-slate-500">
            {picture.name}
          </span>
          <p className="text-xs text-slate-300">
            {picture.originalSize !== picture.size && picture.productID ? (
              <span className="flex items-center">
                {picture?.originalSize}{' '}
                <ArrowRightIcon className="mx-1 size-2 text-slate-500" />{' '}
                {picture?.size} (-
                {picture.saved}%)
              </span>
            ) : (
              <span>{picture?.originalSize}</span>
            )}
          </p>
        </div>
      </td>
      <td className="px-3 py-4 text-sm text-gray-500">
        {picture.productID ? (
          <div className="flex flex-col items-start justify-center">
            <p className="text-sm text-slate-500">{picture.productRef}</p>
            <p className="text-xs text-slate-300">{picture.productName}</p>
          </div>
        ) : (
          <p className="text-sm text-slate-500">
            Aucune référence trouvée
            <br />
            Ajoutez dans la colonne référence &ldquo;
            {picture.ref}&rdquo; ou renommez la photo.
          </p>
        )}
      </td>
    </tr>
  )
}
